import { FC, PropsWithChildren } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { theme } from '@frontend/theme';

export const GradientBar: FC<PropsWithChildren<{ barStyles?: Interpolation<Theme> }>> = ({ barStyles, children }) => {
  return <div css={[styles.header, barStyles]}>{children}</div>;
};

const styles = {
  header: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    position: relative;
    background: linear-gradient(
      90deg,
      #ff7200 -0.03%,
      ${theme.colors.secondary.eggplant50} 50%,
      ${theme.colors.secondary.seaweed50} 100.03%
    );
  `,
};
